module.exports = __webpack_public_path__ + "static/media/imagem5.6f24871a.jpeg";